var e,o;!function(e){e[e.Low=1]="Low",e[e.Mild=2]="Mild",e[e.Severe=3]="Severe"}(e||(e={})),function(e){e.Image="Image",e.Video="Video"}(o||(o={}));export{o as MediaType,e as SeverityValue};
